import { useMemo } from 'react';
import styled from 'styled-components';
import { useTable } from 'react-table';
import Button from '~~elements/Button';
import Multilingual from '../Multilingual';
import moment from 'moment';

export const StyledTableArea = styled.div`
  display: block;
  width: 100%;
  overflow-x: auto;
  overflow-y: hidden;
  font-size: 0.9rem;

  table {
    width: 100%;
    border-spacing: 0;

    tbody > tr {
      :hover {
        background: #b7e9fb;
      }
      border-bottom: 1px solid #eee;
    }

    th {
      white-space: nowrap;
    }

    th,
    td {
      text-align: left;
      margin: 0;
      padding: 0.5rem;
      border-right: 0px;
      :last-child {
        border-right: 0px;
      }

      width: 1%;
      &.collapse {
        width: 0.0000000001%;
      }
    }

    .nowrap {
      white-space: nowrap;
    }
  }
`;

const ListPluginOrders = ({ pluginOrders, handlePluginOrder }) => {
  const columns = useMemo(
    () => [
      {
        Header: Multilingual(`UNIQID`),
        accessor: 'uniqid',
        className: 'nowrap',
      },
      {
        Header: Multilingual(`STATUS.WORDING`),
        accessor: (pluginOrder) => Multilingual(`STATUS.${pluginOrder.status}`),
        className: 'nowrap',
      },
      {
        Header: Multilingual(`PAYMENT_AMOUNT`),
        accessor: (pluginOrder) => `NT$ ${new Intl.NumberFormat('zh-TW').format(pluginOrder.payment_amount)}`,
        className: 'nowrap',
      },
      {
        Header: Multilingual(`CREATED_AT`),
        accessor: (pluginOrder) =>
          !pluginOrder.created_at || !moment(pluginOrder.created_at).isValid()
            ? '-'
            : moment(pluginOrder.created_at).format('YYYY/MM/DD HH:mm'),
        className: 'nowrap',
      },
      {
        Header: Multilingual(`COMMON.VIEW`),
        Cell: ({ row: { original: pluginOrder } }) => {
          return (
            <Button onClick={handlePluginOrder(pluginOrder)} width="auto" color="blue" mini nowrap>
              {Multilingual(`COMMON.VIEW`)}
            </Button>
          );
        },
      },
    ],
    [handlePluginOrder],
  );

  const { getTableProps, getTableBodyProps, rows, headerGroups, prepareRow } = useTable({
    columns,
    data: pluginOrders,
  });

  return (
    <StyledTableArea>
      <table {...getTableProps()}>
        <thead>
          {headerGroups.map((headerGroup) => (
            <tr {...headerGroup.getHeaderGroupProps()}>
              {headerGroup.headers.map((column) => (
                <th {...column.getHeaderProps()}>{column.render('Header')}</th>
              ))}
            </tr>
          ))}
        </thead>
        <tbody {...getTableBodyProps()}>
          {rows.map((row, i) => {
            prepareRow(row);
            return (
              <tr {...row.getRowProps()}>
                {row.cells.map((cell) => {
                  return (
                    <td
                      {...cell.getCellProps({
                        className: cell.column.className,
                      })}
                      style={{ width: cell.column.width }}
                    >
                      {cell.render('Cell')}
                    </td>
                  );
                })}
              </tr>
            );
          })}
        </tbody>
      </table>
    </StyledTableArea>
  );
};

export default ListPluginOrders;
